import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@components/ui/sidebar";
import { MessageCircleIcon, SettingsIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans, useLingui } from "@lingui/react/macro";
import { UserDropdown } from "./UserDropdown";
import { useIntercom } from "@/hooks/useIntercom";
import { INTERCOM_SURVEYS } from "@/intercom";
import useActiveLanguage from "@/hooks/useActiveLanguage";
import { LOCALE } from "@/constants";

export function FooterNav({
  orgUuid,
  pathname,
}: {
  orgUuid: string;
  pathname: string;
}) {
  const { t } = useLingui();
  const { startSurvey } = useIntercom();
  const language = useActiveLanguage();

  const FOOTER_LINKS = [
    {
      label: t`Konto & Inställningar`,
      to: generatePath(ROUTES.SETTINGS_ORGID, { orgUuid }),
      icon: SettingsIcon,
    },
  ];

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          disabled={!startSurvey}
          onClick={() => {
            startSurvey?.(
              language === LOCALE.SWEDISH
                ? INTERCOM_SURVEYS.FEEDBACK_SV
                : INTERCOM_SURVEYS.FEEDBACK_EN
            );
          }}
        >
          <MessageCircleIcon />
          <Trans>Ge feedback</Trans>
        </SidebarMenuButton>
      </SidebarMenuItem>

      {FOOTER_LINKS.map((link) => (
        <SidebarMenuItem key={link.to}>
          <SidebarMenuButton asChild isActive={pathname.startsWith(link.to)}>
            <Link to={link.to}>
              <link.icon />
              {link.label}
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}

      <UserDropdown className="mt-2" orgUuid={orgUuid} />
    </SidebarMenu>
  );
}
